import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setErrorMessage, setIsLoading, setIsToasterError } from "./app";
import API from "../../api/api";

export interface IReclamation {
  client: {
    places: {
      id: string;
      gemeindeBezeichnung: string;
      gemeindePostleitzahl: number;
      gemeindeNummer: number;
    }[];
    streets: {
      id: string;
      gemeindeNummer: number;
      strasseBezeichnung: string;
    }[];
  };
}

const initialState: IReclamation = {
  client: {
    places: [],
    streets: [],
  },
};

export const getLraReclamationStreetsAndPlaces = createAsyncThunk(
  "reclamation/client/getLraReclamationStreetsAndPlaces",
  async (_, { dispatch }) => {
    try {
      dispatch(setIsLoading(true));
      const data = await API.reclamation.get.getReclamationDataLra();

      return data;
    } catch (error: any) {
      dispatch(setIsToasterError(true));
      dispatch(setErrorMessage(error?.response?.data?.message));
    } finally {
      dispatch(setIsLoading(false));
    }
  }
);

export const createLraReclamation = createAsyncThunk(
  "reclamation/client/createLraReclamation",
  async (
    {
      date,
      homeNumber,
      place,
      reasons,
      reclamationReason,
      street,
      type,
      message,
    }: {
      place: string;
      street: string;
      homeNumber: string;
      reclamationReason: string;
      type: string;
      date: string;
      message?: string;
      reasons: string[];
    },
    { dispatch }
  ) => {
    try {
      dispatch(setIsLoading(true));
      await API.reclamation.post.createReclamation({
        date: date,
        homeNumber: homeNumber,
        place: place,
        reclamationReason: reclamationReason,
        street: street,
        type: type,
        message: message,
        reasons: reasons,
      });
    } catch (error: any) {
      dispatch(setIsToasterError(true));
      dispatch(setErrorMessage(error?.response?.data?.message));
    } finally {
      dispatch(setIsLoading(false));
    }
  }
);

const reclamationSlice = createSlice({
  name: "reclamation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLraReclamationStreetsAndPlaces.pending, (state) => {});
    builder.addCase(
      getLraReclamationStreetsAndPlaces.fulfilled,
      (state, action) => {
        if (action.payload) {
          state.client.places = action.payload.places;
          state.client.streets = action.payload.streets;
        }
      }
    );
    builder.addCase(getLraReclamationStreetsAndPlaces.rejected, (state) => {});
  },
});

export const reclamationReducer = reclamationSlice.reducer;
